/**
 * ACL privilege mapping for the "Ultimate Cart" admin module.
 *
 * Registers a single resource key, `sellops_ultimate_cart`, with the four
 * standard Shopware role types. These exact dot-separated strings
 * (`sellops_ultimate_cart.viewer` / `.editor` / `.creator` / `.deleter`)
 * are also what CrossSellRulesAdminController's route `_acl` defaults
 * check server-side — the two MUST stay in sync.
 *
 * - viewer:  can open the module's pages at all (see index.js route meta).
 * - editor:  can create/update/save/reorder/toggle records (button-level
 *            `v-if="acl.can('sellops_ultimate_cart.editor')"` checks).
 * - creator: full-access role, also grants editor.
 * - deleter: can delete records (button-level
 *            `v-if="acl.can('sellops_ultimate_cart.deleter')"` checks).
 */
Shopware.Service('privileges').addPrivilegeMappingEntry({
    category: 'permissions',
    parent: null,
    key: 'sellops_ultimate_cart',
    roles: {
        viewer: {
            privileges: [],
            dependencies: [],
        },
        editor: {
            privileges: [],
            dependencies: [
                'sellops_ultimate_cart.viewer',
            ],
        },
        creator: {
            privileges: [],
            dependencies: [
                'sellops_ultimate_cart.viewer',
                'sellops_ultimate_cart.editor',
            ],
        },
        deleter: {
            privileges: [],
            dependencies: [
                'sellops_ultimate_cart.viewer',
            ],
        },
    },
});
